import ViewWrapper from '../../ViewWrapper';
import { SystemRouter } from '../../../util/RouterUtil';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import BreadCrumb from '../../../component/BreadCrumb';
import { useLocation } from 'react-router-dom';
import BodyTitle from '../../../component/BodyTitle';

const SystemRouterView = () => {
    const auth = AuthenticationUtil.get();
    const pathname = useLocation().pathname;
    return (
        <div className='body-view'>
            <ViewWrapper router={SystemRouter} />
        </div>
    );
};

export default SystemRouterView;
